import ProductGroupingPartialsShoeBack from "./ProductGroupingPartialsShoeBack.component";

export default ProductGroupingPartialsShoeBack;
